// ai娱乐相关页面

export default [
  {
    path: '/thunder/aiphoto/index',
    name: 'aiphoto_index',
    component: () => import('@/views/aiphoto/index.vue'),
    meta: {
      title: '变装合影',
    },
  },
  {
    path: '/thunder/aiphoto/quene',
    name: 'aiphoto_quene',
    component: () => import('@/views/aiphoto/quene.vue'),
    meta: {
      title: '变装合影',
    },
  },
  {
    path: '/thunder/aiphoto/success',
    name: 'aiphoto_success',
    component: () => import('@/views/aiphoto/success.vue'),
    meta: {
      title: '变装合影',
    },
  },
  {
    path: '/thunder/aiphoto/error',
    name: 'aiphoto_error',
    component: () => import('@/views/aiphoto/error.vue'),
    meta: {
      title: '生成失败',
    },
  },
  {
    path: '/thunder/portfolio/index',
    name: 'portfolio',
    component: () => import('@/views/aiphoto/portfolio.vue'),
    meta: {
      title: '我的作品',
    },
  },
  {
    path: '/thunder/starphoto/index',
    name: 'starphoto_index',
    component: () => import('@/views/starphoto/index.vue'),
    meta: {
      title: '明星合照',
    },
  },
  {
    path: '/thunder/starphoto/quene',
    name: 'starphoto_quene',
    component: () => import('@/views/starphoto/quene.vue'),
    meta: {
      title: '明星合照',
    },
  },
  {
    path: '/thunder/starphoto/success',
    name: 'starphoto_success',
    component: () => import('@/views/starphoto/success.vue'),
    meta: {
      title: '明星合照',
    },
  },
  {
    path: '/thunder/wallpaper/list',
    name: 'wallpaper_index',
    component: () => import('@/views/wallpaper/list.vue'),
    meta: {
      title: '手机壁纸'
    }
  },
  {
    path: '/thunder/emoticon',
    name: 'emoticon',
    component: () => import('@/views/emoticon/list.vue'),
    meta: {
      title: '新年表情'
    }
  }
]
